var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8539 0.146028C15.9232 0.21536 15.9705 0.303502 15.99 0.399505C16.0096 0.495508 16.0005 0.595141 15.9639 0.686028L10.1449 15.233C10.0937 15.3611 10.008 15.4726 9.89746 15.5552C9.78691 15.6378 9.65571 15.6883 9.51832 15.7011C9.38092 15.7139 9.24265 15.6886 9.11873 15.6279C8.9948 15.5672 8.89003 15.4734 8.81593 15.357L5.63793 10.362L0.642932 7.18403C0.52625 7.11001 0.432283 7.0052 0.371402 6.88116C0.31052 6.75711 0.285089 6.61866 0.297917 6.48108C0.310744 6.3435 0.36133 6.21214 0.444093 6.10148C0.526855 5.99083 0.638578 5.9052 0.766932 5.85403L15.3139 0.0370277C15.4048 0.000439957 15.5045 -0.00863977 15.6005 0.0109164C15.6965 0.0304726 15.7846 0.0778028 15.8539 0.147028V0.146028ZM6.63593 10.07L9.39693 14.408L14.1299 2.57603L6.63593 10.07ZM13.4229 1.86903L1.59093 6.60203L5.92993 9.36203L13.4239 1.86903H13.4229Z",
    fill: "#5B6670"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaShareIcon);
export default __webpack_public_path__ + "static/media/insta-share-icon.0e2e792acd1211dafa67d74de34a3d27.svg";
export { ForwardRef as ReactComponent };